<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Employees
          </div>
          <div class="card-block">
            <button @click="page--" :disabled="page <= 0">←</button>
            <button @click="page++" :disabled="length * (page + 1) >= employeesList.length">→</button>
            <button @click="showAll()">All</button>
            <button @click="showVisible()">Visible</button>
            <button @click="showPlannable()">Plannable and visible</button>
            <button @click="showPlanInternal()">Plannable internal</button>
            <!--<button class="btn btn-primary btn-sm new-user-btn" @click="newEmployee()"><i class="fa fa-plus"></i> New employee</button>-->
            <table class="table table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Active</th>
                  <th>Show/Hide</th>
                  <th>Plannable</th>
                  <th>Plannable Int</th>
                  <th>Rate Worklogs</th>
                  <th>Display Name</th>
                  <th>E-mail</th>
                  <th>Workload</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="employee in employeesList.slice(page * length, length * (page + 1))"
                  v-if="showEmployee(employee)">
                  <td>{{ employee.id }}</td>
                  <td><i :class="employee.active ? 'fa-check active' : 'fa-times inactive'" class="fa fa-lg"></i></td>
                  <td><i :class="employee.enabled ? 'fa-check active' : 'fa-times inactive'" class="fa fa-lg"></i></td>
                  <td>
                    <i :class="employee.plannable ? 'fa-check active' : 'fa-times inactive'" class="fa fa-lg"></i>
                  </td>
                  <td>
                    <i :class="employee.plan_internal ? 'fa-check active' : 'fa-times inactive'" class="fa fa-lg"></i>
                  </td>
                  <td>
                    <i :class="employee.rate_worklogs ? 'fa-check active' : 'fa-times inactive'" class="fa fa-lg"></i>
                  </td>
                  <td>{{ employee.displayName }}</td>
                  <td>{{ employee.email }}</td>
                  <td>{{ employee.workload }}</td>
                  <td>
                    <!--<i v-if="!employee.external_id" class="fa fa-edit fa-lg action" @click="editEmployee(employee)"></i>-->
                    <i v-if="employee.external_id && (employee.active || employee.enabled)"
                      class="fa fa-edit fa-lg action" @click="editJiraEmployee(employee)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--/.col-->
    </div>
    <!--/.row-->
    <modal :show="false" :backdrop="false" title="Modal title" v-model="editEmployeeModal" @ok="saveEmployee"
      effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">{{ currentEmployee.id ? "Edit" : "New" }} Employee</h4>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label">Display Name</label>
        <div class="col-md-9">
          <input type="text" class="form-control" placeholder="Name" v-model="currentEmployee.displayName">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label">E-mail</label>
        <div class="col-md-9">
          <input type="text" class="form-control" placeholder="E-mail" v-model="currentEmployee.email">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label">Status</label>
        <div class="col-md-9">
          <input type="radio" name="active" :value="1" checked v-model="currentEmployee.active"> Active<br>
          <input type="radio" name="active" :value="0" v-model="currentEmployee.active"> Inactive<br>
        </div>
      </div>
    </modal>
    <modal :show="false" :backdrop="false" title="Modal title" v-model="editJiraEmployeeModal" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">{{ currentJiraEmployee.id ? "Edit" : "New" }} Employee</h4>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label">Display Name</label>
        <div class="col-md-9">
          <input type="text" disabled class="form-control" placeholder="Name" v-model="currentJiraEmployee.displayName">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label">E-mail</label>
        <div class="col-md-9">
          <input type="text" disabled class="form-control" placeholder="E-mail" v-model="currentJiraEmployee.email">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label">Status</label>
        <div class="col-md-9">
          <input type="radio" disabled name="active" :value="1" checked v-model="currentJiraEmployee.active"> Active<br>
          <input type="radio" disabled name="active" :value="0" v-model="currentJiraEmployee.active"> Inactive<br>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label">Show/Hide</label>
        <div class="col-md-9">
          <input type="radio" name="enabled" :checked="currentJiraEmployee.enabled ? 1 : 0"
            @click="currentJiraEmployee.enabled = 1"> Show<br>
          <input type="radio" name="enabled" :checked="!currentJiraEmployee.enabled ? 1 : 0"
            @click="currentJiraEmployee.enabled = 0"> Hide<br>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label">Plannable</label>
        <div class="col-md-9">
          <input type="radio" name="plannable" :checked="currentJiraEmployee.plannable ? 1 : 0"
            @click="currentJiraEmployee.plannable = 1"> Plan as resource<br>
          <input type="radio" name="plannable" :checked="!currentJiraEmployee.plannable ? 1 : 0"
            @click="currentJiraEmployee.plannable = 0"> Skip in planning<br>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label">Plannable internal</label>
        <div class="col-md-9">
          <input type="radio" name="plan_internal" :checked="currentJiraEmployee.plan_internal ? 1 : 0"
            @click="currentJiraEmployee.plan_internal = 1"> Plan as internal resource<br>
          <input type="radio" name="plan_internal" :checked="!currentJiraEmployee.plan_internal ? 1 : 0"
            @click="currentJiraEmployee.plan_internal = 0"> Skip in internal planning<br>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label">Rate worklog quality</label>
        <div class="col-md-9">
          <input type="radio" name="rate_worklogs" :checked="currentJiraEmployee.rate_worklogs ? 1 : 0"
            @click="currentJiraEmployee.rate_worklogs = 1"> Rate worklog quality<br>
          <input type="radio" name="rate_worklogs" :checked="!currentJiraEmployee.rate_worklogs ? 1 : 0"
            @click="currentJiraEmployee.rate_worklogs = 0"> Skip worklog rating<br>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label">Workload</label>
        <div class="col-md-9">
          <input class="form-control" type="number" min="0" max="1" step="0.01"
            v-model="currentJiraEmployee.workload" />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-9"></div>
        <div class="col-md-3">
          <button class="btn btn-primary" @click="saveJiraEmployee()">Save user</button>
        </div>
      </div>
      <hr>
      <user-rates :employeeId="currentJiraEmployee.id"></user-rates>
      <!--<br>-->
      <!--<br>-->
      <!--<hr>-->
      <!--<user-vacation-days v-if="editJiraEmployeeModal" :employeeId="currentJiraEmployee.id"></user-vacation-days>-->
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeEditJiraEmployeeModal()"
          data-dismiss="modal-dialog">Close</button>
      </div>
    </modal>
  </div>
</template>
<style lang="scss" scoped>
.active {
  color: #4dbd74;
}

.inactive {
  color: #f86c6b;
}

.new-user-btn {
  float: right;
  margin-bottom: 10px;
}

.action {
  margin-left: 5px;

  &:hover {
    cursor: pointer;
    color: #ee0044;
  }
}

th,
td {
  padding: 0;
}

tbody>tr:hover {
  background-color: #c8d2d2;
}

#edit-employee-modal {
  z-index: 2;
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
import modal from 'vue-strap/src/Modal';
import VueNotifications from 'vue-notifications';
import UserRates from './UserRateForm.vue';
import UserVacationDays from './UserVacationBalance.vue';

export default {
  name: 'Employees',
  components: {
    modal,
    UserRates,
    UserVacationDays
  },
  data: function () {
    return {
      page: 0,
      length: 20,
      employeesList: [],
      currentEmployee: {},
      currentJiraEmployee: {},
      editJiraEmployeeModal: false,
      editEmployeeModal: false,
      showOnlyVisible: false,
      showOnlyPlannable: false,
      showOnlyPlanInternal: false,
    };
  },
  computed: {
    ...mapGetters('JiraUsers', {
      employees: 'users',
      jiraUserUpdateNotification: 'jiraUserUpdateNotification'
    })
  },
  watch: {
    employees: {
      handler: function () {
        if (this.showOnlyVisible) {
          this.showVisible(this.page);
        } else if (this.showOnlyPlannable) {
          this.showPlannable(this.page);
        } else if (this.showOnlyPlanInternal) {
          this.showPlanInternal(this.page);
        } else {
          this.showAll(this.page);
        }
        //        this.employeesList = Object.values(this.employees);
      },
      deep: true
    },
    editJiraEmployeeModal: function () {
      // if (this.editJiraEmployeeModal == true) {
      //   $('.projects-div').css('z-index', '0');
      // } else {
      //   $('.projects-div').css('z-index', '1');
      // }
    },
    jiraUserUpdateNotification: {
      handler: function (val) {
        if (this.jiraUserUpdateNotification.status == 'success') {
          this.showSuccessMsg({ title: 'Jira user update status', message: this.jiraUserUpdateNotification.message });
        }
        if (this.jiraUserUpdateNotification.status == 'error') {
          for (const i in this.jiraUserUpdateNotification.message) {
            this.showErrorMsg({
              title: 'Jira user update status',
              message: this.jiraUserUpdateNotification.message[i]
            });
          }
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('JiraUsers', ['SAVE_JIRA_USER', 'SAVE_EXISTING_JIRA_USER', 'LOAD_JIRA_USERS']),
    editEmployee(employee) {
      this.currentEmployee = { ...employee };
      this.editEmployeeModal = true;
    },
    editJiraEmployee(employee) {
      this.currentJiraEmployee = { ...employee };
      this.editJiraEmployeeModal = true;
    },
    saveJiraEmployee() {
      this.SAVE_EXISTING_JIRA_USER(this.currentJiraEmployee);
    },
    newEmployee() {
      this.currentEmployee = {
        active: 1,
      };
      this.editEmployeeModal = true;
    },
    saveEmployee() {
      this.SAVE_JIRA_USER(this.currentEmployee);
      this.currentEmployee = {};
      this.editEmployeeModal = false;
    },
    closeEditJiraEmployeeModal() {
      this.currentJiraEmployee = {};
      this.editJiraEmployeeModal = false;
    },
    showEmployee(employee) {
      if (!this.showOnlyVisible) {
        return true;
      }
      if (employee.enabled) {
        return true;
      }
      return false;
    },
    showAll(page = null) {
      this.showOnlyVisible = false;
      this.showOnlyPlannable = false;
      this.showOnlyPlanInternal = false;
      if (!page) {
        this.page = 0;
      }
      //      this.employeesList = [];
      this.employeesList = Object.values(this.employees);
    },
    showVisible(page = null) {
      this.showOnlyVisible = true;
      this.showOnlyPlannable = false;
      this.showOnlyPlanInternal = false;
      if (!page) {
        this.page = 0;
      }
      //      this.employeesList = [];
      const employeesList = [];
      for (const i in this.employees) {
        if (this.employees[i].enabled) {
          employeesList.push(this.employees[i]);
        }
      }
      this.employeesList = employeesList;
    },
    showPlannable(page = null) {
      this.showOnlyPlannable = true;
      this.showOnlyVisible = false;
      this.showOnlyPlanInternal = false;
      if (!page) {
        this.page = 0;
      }
      //      this.employeesList = [];
      const employeesList = [];
      for (const i in this.employees) {
        if (this.employees[i].plannable && this.employees[i].enabled) {
          employeesList.push(this.employees[i]);
        }
      }
      this.employeesList = employeesList;
    },
    showPlanInternal(page = null) {
      this.showOnlyPlannable = false;
      this.showOnlyVisible = false;
      this.showOnlyPlanInternal = true;
      if (!page) {
        this.page = 0;
      }
      //      this.employeesList = [];
      const employeesList = [];
      for (const i in this.employees) {
        if (this.employees[i].plan_internal && this.employees[i].enabled) {
          employeesList.push(this.employees[i]);
        }
      }
      this.employeesList = employeesList;
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  mounted() {
    this.LOAD_JIRA_USERS();
  }
};
</script>
